import React from 'react'
import AddIcon from '@mui/icons-material/Add';



interface CardData {
    id: number
    name: string,
    price: number,
    description: string,
    hasSize: boolean,
    group: string,
    small: number,
    large: number
}
type CardsProps = {
    data: CardData;
    onAdd: (item: CardData) => void;
};
const Cards: React.FC<CardsProps> = ({ data , onAdd }) => {

    return (
        <div className="card" style={{ flex: 1 }} onClick={()=>onAdd(data)}>
            <div>
                {data.name}
            </div>
            <div>
                {data.price ? data.price : data.small}
            </div>
            <div className='text-sm md:text-base'>
                {data.description.length > 65
                    ? data.description.slice(0, 65) + "..."
                    : data.description}
            </div>
            <div
                style={{
                    position: "absolute",
                    border: "3px solid #af0000",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bottom: "15px",
                    right: "10px",
                }}
                onClick={()=>onAdd(data)}
            >
                <AddIcon sx={{ color: "#af0000", fontSize: "24px" , cursor:"pointer"}} />
            </div>
        </div>
    )
}


export default Cards



